module.exports = __webpack_public_path__ + "common/tp-featured1-ba90c0e7e41774a8359a2f6b56683d19.svg";